<div class="homeLoader text-center" *ngIf="homeLoader">
    <img src="../../../assets/images/32.svg">
</div>
<app-header class="header" [ngClass]="{'scrolled-background': isScrolled}"></app-header>
<div class="bg-image">
    <div class="container bgContainer">
        <div class="row justify-content-center details">
            <h2>Easy planning for what matters most:</h2>
            <h3>
                <!-- <span class="span1">How will you leave an eternal impact?</span>
                <span class="span2">Does your Will insure your desires will be honored?</span>
                <span class="span3">What will your Legacy be?</span>
                <span class="span4">Are you supporting your loved ones or burdening them?</span>
                <span class="span5">Do you want prayers for your soul?</span>
                <span class="span6">We are here to help!</span>   -->
                <span class="span1">Will Your Legacy Reflect Your Faith?</span>
                <span class="span2">Do You Want to Control Your Healthcare Decisions?</span>
                <span class="span3">Do You Want to Provide Peace to Your Loved Ones?</span>
                <span class="span4">We Are Here to Help!</span>
            </h3>
            <button class="btn btn-primary btn-block" (click)="scroll(formSection)">BEGIN NOW</button>
        </div>
    </div>
</div>
<!-- Deployment testing -->
<div class="parallex">
    <div class="forms-wrapper" #formSection>
        <div class="will d-flex align-items-center" *ngFor="let data of formData; let i = index">
            <div class="container" *ngIf="i % 2 == 0">
                <div class="row">
                    <div class="col-lg-12 col-xl-5 mx-auto">
                        <div class="img-wrap">
                            <img loading="lazy" [src]="data.image" alt="Will-image">
                        </div>
                    </div>
                    <div class="col-lg-12 col-xl-7 mx-auto detail">
                        <h2>{{data.title}}</h2>
                        <p [innerHTML]="data.statisticDescription"></p>
                        <!-- Animation - [id]="i === 0 ? 'scrollFirst' : i === 2 ? 'scrollThird' : ''" -->
                        <div>
                            <p [innerHTML]="data.description"></p>
                            <button class="btn btn-primary btn-block"
                                (click)="goToForm(data._id)">{{data.buttonLabel}}</button>
                        </div>
                    </div>
                </div>
            </div>
            <div class="container" *ngIf="i % 2 != 0">
                <div class="row middle-row">
                    <div class="col-lg-12 col-xl-7 mx-auto detail">
                        <h2>{{data.title}}</h2>
                        <p [innerHTML]="data.statisticDescription"></p>
                        <!-- Animation - id="scrollSecond" -->
                        <div>
                            <p [innerHTML]="data.description"></p>
                            <button class="btn btn-primary btn-block"
                                (click)="goToForm(data._id)">{{data.buttonLabel}}</button>
                        </div>
                    </div>
                    <div class="col-lg-12 col-xl-5 mx-auto d-flex justify-content-end">
                        <div class="img-wrap">
                            <img loading="lazy" [src]="data.image" alt="Will-image">
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- <div class="will d-flex align-items-center">
            <div class="container">
                <div class="row">
                    <div class="col-lg-12 col-xl-5 mx-auto">
                        <div class="img-wrap">
                            <img src="../../../assets/images/will-img.webp" alt="Will-image">
                        </div>
                    </div>
                    <div class="col-lg-12 col-xl-7 mx-auto detail">
                        <h2>Peace of Mind with a Free Catholic Will</h2>
                        <div class="numbers"><p>100+ wills created  <span>|</span>  $10B+ Committed to nonprofits</p></div>
                        <p>In as little as 18 minutes, walk through the steps of creating a Will with our easy to use web form.</p>
                        <div id="scrollFirst">
                            <ul>
                                <li>Catholic Legacy is a trusted partner, having vetted our service with world class attorneys and Doctors of Canon Law.</li>
                                <li>Being a non-profit, we are able to offer this service free as a part of our mission to help Catholics prepare for the future.</li>
                            </ul>
                            <button class="btn btn-primary btn-block">MAKE MY WILL NOW</button>
                        </div>
                    </div>
                </div>
            </div>
        </div> -->
        <!-- <div class="funeral d-flex align-items-center">
            <div class="container">
                <div class="row">
                    <div class="col-lg-12 col-xl-7 mx-auto detail">
                        <h2>Funeral Mass, Wake, and Cemetery Planning</h2>
                        <div class="numbers"><p>60k+ People Planned funeral</p></div>
                        <p>A free guide to make your intentions known and make the process easier for your loved ones at a difficult time.</p>
                        <div id="scrollSecond">
                            <ul>
                                <li>Make preparations for Masses to be said for you soul.</li>
                                <li>This planning guide can also be used to make arrangements for a loved one that has already passed away.</li>
                            </ul>
                            <button class="btn btn-primary btn-block">CREATE A PLAN NOW</button>
                        </div>
                    </div>
                    <div class="col-lg-12 col-xl-5 mx-auto d-flex justify-content-end">
                        <div class="img-wrap">
                            <img src="../../../assets/images/funeral-img.webp" alt="Will-image">
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="health d-flex align-items-center">
            <div class="container">
                <div class="row">
                    <div class="col-lg-12 col-xl-5 mx-auto">
                        <div class="img-wrap">
                            <img src="../../../assets/images/health-img.webp" alt="Will-image">
                        </div>
                    </div>
                    <div class="col-lg-12 col-xl-7 mx-auto detail">
                        <h2>Authentically Catholic Healthcare Directive</h2>
                        <div class="numbers"><p>250+ Completed Health Care</p></div>
                        <p>Also known as a living will, this allows you to have control over what happens to you when you can’t speak for yourself</p>
                        <div id="scrollThird">
                            <ul>
                                <li>Don’t let the government or hospitals make decisions for you that will violate your faith. </li>
                                <li>Prevent expensive healthcare costs from treatments you don't need.</li>
                            </ul>
                            <button class="btn btn-primary btn-block">DESIGN MY FREE HEALTHCARE DIRECTIVE</button>
                        </div>
                    </div>
                </div>
            </div>
        </div> -->
    </div>
    <!-- <div class="completed-will-wrapper">
        <div class="container">
            <div id="completedWill" class="carousel slide" data-bs-ride="carousel">
                <h3>Join the thousands of other who have secured their legacy with Catholic Legacy</h3>
                <div class="carousel-inner">
                    <div class="carousel-item" [ngClass]="i === 0 ? 'active': ''" data-bs-interval="2000" *ngFor="let data of formData; let i = index">
                        <div class="row contract-wrap">
                            <div class="col-lg-12 col-xl-10 d-flex">
                                <div class="img-wrap">
                                    <img src="../../../assets/images/contract.svg" alt="Contract">
                                </div>
                                <div class="detail-wrap">
                                    <h3>Number of {{data.title}} completed</h3>
                                    <p>Nam libero tempore, cum soluta nobis est eligendi optio cumque nihil impedit quo minus id quod maxime placeat facere possimus</p>
                                </div>
                            </div>
                            
                        </div>
                    </div>
                    
                </div>
                <button class="carousel-control-prev" type="button" data-bs-target="#completedWill" data-bs-slide="prev">
                  <span class="carousel-control-prev-icon" aria-hidden="true"></span>
                  <span class="visually-hidden">Previous</span>
                </button>
                <button class="carousel-control-next" type="button" data-bs-target="#completedWill" data-bs-slide="next">
                  <span class="carousel-control-next-icon" aria-hidden="true"></span>
                  <span class="visually-hidden">Next</span>
                </button>
            </div>
        </div>
    </div> -->
    <app-landing></app-landing>
    <app-resources-slider id="videoSection"></app-resources-slider>
</div>
<app-footer></app-footer>